/*
 * @Author: Teemo Ding
 * @Date: 2021-04-21 10:40:58
 * @LastEditTime: 2022-10-20 11:36:06
 * @LastEditors: Teemo Ding
 * @Description: Preview
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductContent/Preview/index.tsx
 */

import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  ProductComment,
  ProductDetailCarousel,
  ProductInformation,
} from 'unifyxp-ecomm-components';

import { withDraggableId } from 'src/constrains/Preview/util';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { EnumCollapseId, ProductType } from '../common';
import { getContent, onCollapseOpen } from '../slice';
import styles from './style.module.less';
import { Module, ModuleList } from './util';

interface IProps {
  order: Array<Module>;
  getModulesContent: any;
  getCollapseStatus: any;
  translationEnabled: boolean;
}
const Preview = ({
  order,
  getCollapseStatus,
  getModulesContent,
  translationEnabled,
}: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const productContent = useSelector(getContent('contentDetails'));
  const productCarousel = useSelector(getContent('carousel'));
  const reviewKeywords = useSelector(getContent('reviewKeywords'));
  const productType = useSelector(getContent('productType'));
  const { linkModules = [] } = useSelector(getContent('thumbnailImage'));
  const averageRating = useSelector(getContent('averageRating'));
  const reviewCount = useSelector(getContent('reviewCount'));
  const reviewDisplayed = useSelector(getContent('reviewDisplayed'));
  const {
    productName,
    productSubtitle,
    contentPrice = [],
    currency,
    productDescription,
  } = productContent;
  const { dynamicData, staticData } = productCarousel;
  const { autoPlay, intervalTime } = staticData || {};
  const thumbnailImageImageList = linkModules.map((item) => ({
    url: (item.linkImage || {}).url,
    quantity: item.title || '',
  }));

  const contentPriceCopy = _.cloneDeep(contentPrice);
  contentPriceCopy.sort();
  const product = {
    title: productName || '',
    subTitle: productSubtitle || '',
    isSoldOut: false,
    lp:
      contentPriceCopy && contentPriceCopy.length > 1
        ? `${currency || ''} ${contentPriceCopy[0]} - ${
            contentPriceCopy[contentPriceCopy.length - 1]
          }`
        : `${currency || ''} ${contentPriceCopy[0] || ''}`,
    skuData:
      thumbnailImageImageList.length > 1
        ? {
            title: getI18n(
              'salesChannelProductContent.index.pleaseselectcategory',
            ),
            skus: thumbnailImageImageList || [],
          }
        : null,
  };

  const _ProductDetailCarousel = withDraggableId(
    ProductDetailCarousel,
    EnumCollapseId.carousel,
    onCollapseOpen,
  );
  const _ProductInformation = withDraggableId(
    ProductInformation,
    EnumCollapseId.contentDetails,
    onCollapseOpen,
  );

  const _ProductComments = withDraggableId(
    ProductComment,
    EnumCollapseId.reviewKeywords,
    onCollapseOpen,
  );

  const rawData = {
    moduleContentOrder: order,
  };

  const dynamicDataSort = dynamicData.reduce((acc, item) => {
    if (item.coverImage === true) {
      acc.unshift(item);
    } else {
      acc.push(item);
    }
    return acc;
  }, []);

  const carouselImage = (dynamicDataSort || []).map(
    (item) => ((item.linkModule || {}).linkImage || {}).url,
  );

  const carouselImageList =
    productType == ProductType.MultiplePhysical ||
    productType == ProductType.MultipleVirtual
      ? carouselImage.concat(
          (thumbnailImageImageList || []).map((item) => (item || {}).url),
        )
      : carouselImage;

  return (
    <div
      className={styles.container}
      style={
        translationEnabled ? { top: '65px', height: 'calc(100vh - 260px)' } : {}
      }>
      <_ProductDetailCarousel
        data={carouselImageList}
        autoPlay={autoPlay}
        interval={intervalTime * 1000}
      />
      <div className={styles.informationContainer}>
        <_ProductInformation
          product={product}
          style={{ background: '#ffffff' }}
        />
      </div>
      {productDescription && (
        <div className={styles.productDescription}>
          <h3 className={styles.productDescriptionTitle}>
            {getI18n('general.hOCTitle.productDetails')}
          </h3>
          <p>{productDescription}</p>
        </div>
      )}
      {reviewDisplayed && (
        <_ProductComments
          rating={averageRating}
          num={reviewCount}
          tags={reviewKeywords.tags}
        />
      )}
      <ModuleList
        rawData={rawData}
        getContent={getModulesContent}
        getCollapseStatus={getCollapseStatus}
      />
    </div>
  );
};

export default Preview;
